import { ReactNode, HTMLAttributes } from "react";

import './CardHeader.scss';

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
	variant?: string;
	children: ReactNode;
}

export function CardHeader({children, variant, ...rest}: CardHeaderProps) {
	return(
		<div className={`card-header ${variant ? variant : ''}`} {...rest}>{children}</div>
	)
}
